// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2mGu8","col":"Table_col__21mLk","fulfillmentStatus":"Table_fulfillmentStatus__320mj","emailCol":"Table_emailCol__3WR9L"};